<aside class="wrapper-satellite-lock-create">
  <div class="col-md-12">
    <div class="row px-0 px-sm-4">
      <div class="col-md-12 wrapper-detail">
        <!-- Form Container -->
        <div class="form-container">
          <form [formGroup]="satelliteLockForm" (ngSubmit)="onSubmit()">
            <div class="container-card-row mt-4">
              <div class="form-fields-container">
                <div class="row">

                  <!-- IMEI -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>IMEI del dispositivo <span class="asterisk">*</span></mat-label>
                      <input matInput formControlName="imei" placeholder="123456789012345"
                        [class.mat-form-field-invalid]="hasError('imei')" onlyNumbersInt>
                      <mat-error *ngIf="hasError('imei')">
                        {{ getErrorMessage('imei') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Consecutivo -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Consecutivo Externo<span class="asterisk">*</span></mat-label>
                      <input matInput formControlName="consecutive" placeholder="Ej: 0001"
                        [class.mat-form-field-invalid]="hasError('consecutive')" onlyNumbersInt>
                      <mat-error *ngIf="hasError('consecutive')">
                        {{ getErrorMessage('consecutive') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Tipo -->
                  <div class="col-md-6">
                    <app-autocomplete-satellite-lock-type [options]="typeAutocompleteOptions"
                      [inputFormControl]="satelliteLockForm.get('type')" [validate]="typeValidate">
                    </app-autocomplete-satellite-lock-type>
                  </div>

                  <!-- ID -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>ID del dispositivo <span class="asterisk">*</span></mat-label>
                      <input matInput formControlName="id" placeholder="Ej: LOCK-001"
                        [pattern]="patterns.SATELLITE_LOCK_ID_FIRMWARE.source"
                        [class.mat-form-field-invalid]="hasError('id')">
                      <mat-error *ngIf="hasError('id')">
                        {{ getErrorMessage('id') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Estado del Dispositivo -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Estado del Dispositivo <span class="asterisk">*</span></mat-label>
                      <mat-select formControlName="stateDevice"
                        [class.mat-form-field-invalid]="hasError('stateDevice')">
                        <mat-option *ngFor="let option of stateDeviceOptions" [value]="option.value">
                          {{ option.label }}
                        </mat-option>
                      </mat-select>
                      <mat-error *ngIf="hasError('stateDevice')">
                        {{ getErrorMessage('stateDevice') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Descripción
                        <span class="asterisk"
                          *ngIf="satelliteLockForm.get('stateDevice') && satelliteLockForm.get('stateDevice').value !== SatelliteLockStateDevice.ACTIVE">*</span>
                      </mat-label>
                      <input matInput formControlName="description"
                        placeholder="Descripción adicional del candado satelital"
                        [class.mat-form-field-invalid]="hasError('description')">
                      <mat-error *ngIf="hasError('description')">
                        {{ getErrorMessage('description') }}
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Versión de Firmware -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Versión de Firmware <span class="optional">(opcional)</span></mat-label>
                      <input matInput formControlName="firmwareVersion" placeholder="Ej: 1.0.3"
                        [pattern]="patterns.SATELLITE_LOCK_ID_FIRMWARE.source">
                      <mat-error *ngIf="hasError('firmwareVersion')">
                        {{ getErrorMessage('firmwareVersion') }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>

                <!-- Imagen -->
                <div class="row">
                  <div class="col-md-6">
                    <input #inputImage class="display-none" type="file" accept="image/*"
                      (change)="setInstanceFileStorage($event)">
                    <mat-form-field appearance="standard" (click)="openWindowFile()" class="w-100">
                      <mat-label>Imagen del dispositivo</mat-label>
                      <input matInput type="text" class="field__form--input" readonly [formControl]="visualImage">
                      <i class="fas fa-paperclip" matSuffix></i>
                    </mat-form-field>
                    <div *ngIf="loadingImage && visualImage?.value" class="spinner-container">
                      <i class="fas fa-spinner fa-spin"></i>
                    </div>
                    <ng-container *ngIf="imageResource || errorLoadImage">
                      <app-previsualization-resources [resource]="imageResource" [errorLoadResource]="errorLoadImage">
                      </app-previsualization-resources>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="d-flex justify-content-center gap-3 mt-4 w-100">
              <button mat-raised-button type="submit" color="primary" class="bg-color-primary">
                Crear Candado
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</aside>